<template>
  <div>
    <h6>區域清單</h6>
    <vuetable ref="vuetable"
    :api-url="`${server}/api/area/`"
    data-path=""
    pagination-path=""
    :fields="fields"
    :api-mode="true"
    :css="boostrapCss"
    :http-options="httpOptions"
    @vuetable:cell-clicked="onCellClicked">
      <template slot-scope="props" slot="actions">
        <button class="btn btn-danger" @click="deleteArea(props.rowData.id)">刪除</button>
      </template>
    </vuetable>

    <hr>
    
    <div class="form-group row">
      <label for="" class="col-sm-2 col-form-label">區域名稱</label>
      <div class="col-sm-10">
        <input class="form-control" v-model="areaName"></input>
      </div>
    </div>
    <div class="form-group row">
      <label for="" class="col-sm-2 col-form-label">所屬單位</label>
      <div class="col-sm-10">
        <select class="form-control" v-model="selectedDepartment">
          <option :value="dep.id" v-for="dep in departments">{{ dep.name }}</option>
        </select>
      </div>
    </div>
    <button class="btn btn-primary" @click="createArea">新增區域</button>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import Vuetable from 'vuetable-2/src/components/Vuetable';
import readCookie from '@/vuex/functions/readCookie';
import server from '@/config';
import AreaSettingsDetail from './AreaSettingsDetail';

Vue.component('area-settings-detail', AreaSettingsDetail);

export default {
  name: 'ADCList',
  data() {
    return {
      boostrapCss: {
        tableClass: 'table table-striped table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        },
      },
      httpOptions: {
        headers: {
          Authorization: `Token ${readCookie('Token')}`,
        },
      },
      server,
      fields: [
        {
          name: 'name',
          title: '區域名稱',
        },
        {
          name: 'department.name',
          title: '所屬單位',
        },
        {
          name: '__slot:actions',
          title: '動作',
        },
      ],
      areaName: '',
      departments: [],
      selectedDepartment: '',
    };
  },
  components: {
    Vuetable,
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
  },
  created() {
    this.getDepartment();
  },
  methods: {
    onCellClicked(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.id);
    },
    getDepartment() {
      this.instance.get('/api/department/')
      .then((res) => {
        this.departments = res.data;
      });
    },
    createArea() {
      this.instance.post('/api/area/', {
        name: this.areaName,
        department: this.selectedDepartment,
      })
      .then(() => {
        this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '新增成功',
        });
        this.$refs.vuetable.refresh();
      });
    },
    deleteArea(id) {
      this.instance.delete(`/api/area/${id}/`)
      .then(() => {
        this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '刪除成功',
        });
        this.$refs.vuetable.refresh();
      });
    },
  },
};
</script>




// WEBPACK FOOTER //
// AreaSettings.vue?36980560